module.exports = __webpack_public_path__ + "static/img/4.b9440f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/5/1/sp/4.png
// module id = QlkN
// module chunks = 0